<template>
	<div class="flow-tabs-container" :no-content="$slots['content'] ? false : true">
		<!-- @slot Used to display List of Tab component -->
		<div
			class="flow-tabs-wrapper flow-add-scrollbar"
			:type="type"
			:data-sticky="sticky"
			:data-size="size"
		>
			<slot />
		</div>
		<div
			v-if="$slots['content']"
			class="flow-tabs-content-wrapper flow-add-scrollbar"
			:data-size="size"
		>
			<slot name="content" />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "Tabs",
	props: {
		type: {
			type: String,
			default: "transparent",

			validator(value) {
				return ["transparent", "filled"].includes(value);
			}
		},
		/**
		 * Tab will stick to top
		 */
		sticky: {
			type: Boolean,
			default: false
		},
		/**
		 * 'regular' | 'small'
		 */
		size: {
			type: String,
			default: "regular",
			validator(value) {
				return ["regular", "small"].includes(value);
			}
		}
	}
});
</script>
<style lang="scss">
$sizes: (
	"regular": 44px,
	"small": 36px
);
div.flow-tabs-container {
	display: flex;
	flex-direction: column;

	> div.flow-tabs-wrapper {
		display: flex;
		overflow-x: auto;
		position: relative;
		flex-shrink: 0;
		@each $name, $size in $sizes {
			&[data-size="#{$name}"] {
				height: $size;
			}
		}
		&[data-size="small"] {
			div.flow-tab {
				padding: 8px;
			}
		}
		// border-bottom: 1px solid var(--slideout-border);
		&[type="transparent"] {
			&:after {
				position: absolute;
				content: "";
				left: 0px;
				bottom: 1px;
				right: 0px;
				z-index: 1;
			}
		}

		> [type="filled"] {
			margin-right: 8px;
			&:last-child {
				margin-right: 0px;
			}
		}

		&[data-sticky] {
			position: sticky;
			top: 0px;
			background-color: var(--dashboard-element-light);
			z-index: 3;
		}
	}

	> div.flow-tabs-content-wrapper {
		@each $name, $size in $sizes {
			&[data-size="#{$name}"] {
				height: calc(100% - #{$size});
			}
		}
		overflow: auto;
		> div.container {
			height: 100%;
		}
	}
}

@mixin tabs-mixin($border) {
	div.flow-tabs-container {
		> div.flow-tabs-wrapper {
			&:after {
				border-bottom: 1px solid $border;
			}
		}
	}
}

div.sideout-container {
	@include tabs-mixin(var(--slideout-border-light));
}

@include tabs-mixin(var(--dashboard-border-light));
</style>
